module.exports = __webpack_public_path__ + "img/42.4b3cf536.jpg";